import { CustomCellRendererProps } from "ag-grid-react";
import { Box, Tooltip, Typography, useTheme } from "@material-ui/core";
import { GDPRConsentRecordsDataFragment, GDPRConsentType } from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { ConsultantRowData } from "../../../utils/consultant-row-data";
import {
  ConsentState,
  buildConsentTooltip,
  findJobMailingConsent,
  resolveConsentState
} from "./gdpr-job-mailing-consent";

type Props = CustomCellRendererProps<ConsultantRowData>;

export function GdprJobMailingRenderer(props: Props) {
  const theme = useTheme();

  const records = props.data?.GDPRConsentRecords;
  const emailConsent = findJobMailingConsent(records, GDPRConsentType.JobMailingEmail);
  const smsConsent = findJobMailingConsent(records, GDPRConsentType.JobMailingSms);

  const colorByState: Record<ConsentState, string> = {
    granted: theme.palette.success.light,
    revoked: theme.palette.error.light,
    unknown: theme.palette.grey[300]
  };

  const renderIndicator = (label: string, consent?: GDPRConsentRecordsDataFragment) => {
    const state = resolveConsentState(consent);

    return (
      <Tooltip title={buildConsentTooltip(consent)}>
        <Box
          style={{
            backgroundColor: colorByState[state],
            borderRadius: 4,
            padding: "2px 6px"
          }}
        >
          <Typography variant="caption" display="block">
            {label}
          </Typography>
        </Box>
      </Tooltip>
    );
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      height="100%"
      width="100%"
      style={{ gap: 4 }}
      p={0.5}
    >
      {renderIndicator(locale.Email, emailConsent)}
      {renderIndicator(locale.SMS, smsConsent)}
    </Box>
  );
}
